<app-page-breadcrumb pageTitle="Reglas de routing"></app-page-breadcrumb>

<div class="space-y-4">
  <div class="flex items-center justify-end">
    <button type="button" *appHasPermission="'meetings:create'" (click)="crear()"
      class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
      </svg>
      Nueva regla
    </button>
  </div>

  @if (error) { <p class="text-sm text-error-600">{{ error }}</p> }

  @if (loading) {
    <div class="flex justify-center py-12">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    </div>
  } @else if (items.length === 0) {
    <p class="text-sm text-gray-500 dark:text-gray-400 py-4">No hay reglas configuradas.</p>
  } @else {
    <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
      <table class="min-w-full">
        <thead class="border-b border-gray-100 dark:border-white/[0.05]">
          <tr>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400 w-16">#</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Nombre</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Tipo</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Página de reserva</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Destino</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
          @for (item of items; track item.id) {
            <tr>
              <td class="px-4 py-3 text-sm text-gray-500 dark:text-gray-400">{{ item.priorityOrder ?? '—' }}</td>
              <td class="px-4 py-3 text-sm font-medium text-gray-800 dark:text-white/90">{{ item.ruleName }}</td>
              <td class="px-4 py-3 text-sm">
                <span class="text-xs px-2 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300">{{ ruleTypeLabel(item.ruleType) }}</span>
              </td>
              <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                @if (item.idBookingLink && bookingLinkName(item.idBookingLink)) {
                  <span [title]="'Identificador interno: ' + item.idBookingLink">{{ bookingLinkName(item.idBookingLink) }}</span>
                } @else { <span class="text-gray-400">—</span> }
              </td>
              <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                @if (item.userTargetId && userTargetName(item.userTargetId)) {
                  <span [title]="'Identificador interno: ' + item.userTargetId">{{ userTargetName(item.userTargetId) }}</span>
                } @else { <span class="text-gray-400">—</span> }
              </td>
              <td class="px-4 py-3 text-sm">
                @if (item.isActive) {
                  <span class="text-xs px-2 py-0.5 rounded bg-success-100 text-success-700">Activa</span>
                } @else {
                  <span class="text-xs px-2 py-0.5 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300">Inactiva</span>
                }
              </td>
              <td class="px-4 py-3 text-sm text-center">
                <div class="flex items-center justify-center gap-2">
                  <button *appHasPermission="'meetings:edit'" (click)="editar(item)"
                    class="text-xs px-2 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300">Editar</button>
                  <button *appHasPermission="'meetings:delete'" (click)="eliminar(item)"
                    class="text-xs px-2 py-1 rounded border border-error-300 text-error-600 hover:bg-error-50">Eliminar</button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
